import { render, staticRenderFns } from "./JobSafety.vue?vue&type=template&id=045f151f&scoped=true"
import script from "./JobSafety.vue?vue&type=script&lang=js"
export * from "./JobSafety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f151f",
  null
  
)

export default component.exports